import { useEffect, useMemo } from 'react';
// @ts-ignore
import FaviconNotification from 'favicon-notification';
import { useTranslation } from 'react-i18next';
import useChatContacts from './useChatContacts';
import useSessionChats from './useSessionChats';
import getUnreadChatsCount from '../../utils/getUnreadChatsCount';

FaviconNotification.init({
  color: '#ff1053',
  lineColor: '#FFFFFF',
});

const useWindowTitleNotification = () => {
  const { contacts } = useChatContacts();
  const { chats } = useSessionChats();
  const { t } = useTranslation();

  const count = useMemo(() => getUnreadChatsCount(contacts, chats), [contacts, chats]);

  useEffect(() => {
    window.document.title = t('window_title', {
      count,
      context: count ? 'with_notification' : undefined,
    });

    if (count > 0) {
      FaviconNotification.add();
    } else {
      FaviconNotification.remove();
    }
  }, [count, t]);
};

export default useWindowTitleNotification;
